import { render, staticRenderFns } from "./AnimatedDecimalNumber.vue?vue&type=template&id=22880991"
import script from "./AnimatedDecimalNumber.vue?vue&type=script&lang=js"
export * from "./AnimatedDecimalNumber.vue?vue&type=script&lang=js"
import style0 from "./AnimatedDecimalNumber.vue?vue&type=style&index=0&id=22880991&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports